










































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

// Types
import { IActionControl } from "@/models/ui";

@Component
export default class ClientSupportTicketControls extends Mixins(
  SupportTicketInjectorMixin
) {
  // Computed

  public get hasOneAction() {
    return this.ticketData.actions.length === 1;
  }

  public get action(): IActionControl {
    return this.ticketData?.actions[0];
  }
}
